import { useWebSocket } from "../../../shared/contexts";
import { ChatMode } from "./types";

/**
 * Доступность чата для UI вокруг панели (тогл, место под панель).
 *
 * Fail closed: любой режим кроме viewer-aware означает, что чата нет —
 * та же проверка, что и внутри `ChatPanel`.
 */
export function useIsChatAvailable(): boolean {
  const { chatMode } = useWebSocket();
  return chatMode === ChatMode.CHAT_MODE_VIEWER_AWARE;
}
